import { createDarkFamilyComponents } from '../dark-family/create-components'

export const createComponents = ({ palette }) =>
    createDarkFamilyComponents({
        palette,
        tweaks: {
            appBarAlpha: 0.9,
            paperAlpha: 0.94,
            elevatedSurfaceAlpha: 0.94,
            tableHeadAlpha: 0.06,
            borderAlpha: 0.12
        }
    })
